var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-date",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"hour"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.value.timeSlot.start.value,'LT')))])])}
var staticRenderFns = []

export { render, staticRenderFns }